import { getItemCodeLevel, hasChildItems } from "./itemHierarchy";

const valueOf = (item, key) => item?.[key] ?? item?.[`${key[0].toUpperCase()}${key.slice(1)}`];

export const getDraftParentError = (parentId, items = []) => {
  if (!parentId) return "";
  const parent = items.find((item) => String(valueOf(item, "drafItemId")) === String(parentId));
  if (!parent || String(valueOf(parent, "drafAction")).toUpperCase() === "DELETE") {
    return "Dự toán cha không thuộc phạm vi hoặc đã đánh dấu xóa.";
  }
  if (getItemCodeLevel(valueOf(parent, "itemCode")) >= 4) return "Dự toán chỉ hỗ trợ tối đa 4 cấp.";
  const hasChildren = hasChildItems(parent) || items.some((item) =>
    String(valueOf(item, "drafParentItemId")) === String(parentId));
  const isExecutedLeaf = !hasChildren && Number(valueOf(parent, "subcontractQuantity")) > 0
    && Number(valueOf(parent, "unitPrice")) > 0 && Number(valueOf(parent, "subcontractAmount")) > 0
    && String(valueOf(parent, "unit") ?? "").trim();
  return isExecutedLeaf ? "Không thể thêm dự toán con vào hạng mục công việc đã có dữ liệu thực thi. Vui lòng chọn hạng mục cha khác." : "";
};
